
      var _rect, _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgDebtPayment = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 56,
  height: 56,
  viewBox: "0 0 56 56",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 9,
  y: 17,
  width: 41,
  height: 29,
  rx: 4
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M9.002 14v28a3.5 3.5 0 0 0 3.5 3.5h35a1.75 1.75 0 0 0 1.75-1.75v-24.5a1.75 1.75 0 0 0-1.75-1.75h-35a3.5 3.5 0 0 1-3.5-3.5v0a3.5 3.5 0 0 1 3.5-3.5h29.75",
  stroke: "var(--theme-primary, #810ea9)",
  strokeWidth: 2.75,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 39.627,
  cy: 31.5,
  r: 2.625,
  fill: "var(--theme-primary, #810ea9)"
})));

      const __svgRaw = "<svg width=\"56\" height=\"56\" viewBox=\"0 0 56 56\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\r\n    <rect x=\"9\" y=\"17\" width=\"41\" height=\"29\" rx=\"4\"/>\r\n    <path d=\"M9.002 14v28a3.5 3.5 0 0 0 3.5 3.5h35a1.75 1.75 0 0 0 1.75-1.75v-24.5a1.75 1.75 0 0 0-1.75-1.75h-35a3.5 3.5 0 0 1-3.5-3.5v0a3.5 3.5 0 0 1 3.5-3.5h29.75\" stroke=\"var(--theme-primary, #810ea9)\" stroke-width=\"2.75\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\r\n    <circle cx=\"39.627\" cy=\"31.5\" r=\"2.625\" fill=\"var(--theme-primary, #810ea9)\"/>\r\n</svg>";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/debt-payment.c41d892e86d03022825518391852455d.svg"),
        {
          React: SvgDebtPayment,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      